import * as React from "react";

import Icon1 from "../icons/Icon";
import Space from "../layout/Space";
import PrimaryButton from "../buttons/PrimaryButton";

import Modal1 from "../modals/Modal1";
import { useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import WarningButton from "../buttons/WarningButton";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useAppContext } from "../config/AppContext";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import TextField2 from "../textfields/TextField2";
import { Spin } from "antd";

export default function ClientsAM({
  masterData,
  clientData,
  userData,
  actionModify,
  navigateWorkspace,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [loadingDelete, setLoadingDelete] = useState(false);
  const [confirm_text, setConfirmText] = useState("");
  const handleDeleteClient = async () => {
    setLoadingDelete(true);
    setOpenDelete(false);
    let alert_clients = masterData.alerts?.clients || [];
    alert_clients = alert_clients.filter((client) => client !== clientData.id);
    await updateDocDataFieldApi(
      masterData.ref,
      "alerts.clients",
      alert_clients,
      prefix
    );
    const token = await getOrRefreshFirebaseToken();
    // await deleteClient(masterData.id, clientData.id, token, prefix);
    navigateWorkspace("/clients");
    setLoadingDelete(false);
  };

  const [openDelete, setOpenDelete] = useState(false);

  return (
    <div>
      <Modal1 isOpen={openDelete} onClose={() => setOpenDelete(false)}>
        <div className=" flex flex-col bg-white rounded-xl p-4">
          <div className="text-h2">
            Voulez-vous vraiment supprimer cet élément ?
          </div>
          <div className="text-h3 text-shadow_50 my-4">
            Cette action est <span className="text-red-500">irréversible</span>.
          </div>
          <div className="text-h3 text-shadow_50 mb-4">
            Elle entraîne la suppression définitive de ces éléments.
          </div>
          <div className="text-h3 text-shadow_50">- Membres de l'équipe</div>
          <div className="text-h3 text-shadow_50 ">- Dossiers</div>
          <div className="text-h3 text-shadow_50 ">- Messages</div>
          <div className="text-h3 text-shadow_50 ">- Devis</div>
          <div className="text-h3 text-shadow_50 ">- Evènements</div>
          <div className="text-h3 text-shadow_50 my-4">
            Entrez CONFIRMER pour confirmer la suppression.
          </div>
          <TextField2
            label="CONFIRMER"
            value={confirm_text}
            onChange={(e) => setConfirmText(e.target.value)}
          ></TextField2>
          <Space y={20} />
          {!loadingDelete && (
            <div className="flex flex-row justify-end gap-2 ">
              <SecondaryButton onClick={() => setOpenDelete(false)}>
                Annuler
              </SecondaryButton>
              <WarningButton
                disabled={confirm_text != "CONFIRMER"}
                onClick={handleDeleteClient}
              >
                Supprimer
              </WarningButton>
            </div>
          )}
          {loadingDelete && <Spin spinning={true} size="small"></Spin>}
        </div>
      </Modal1>
      <div className="relative">
        <PrimaryButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <div className="flex flex-row gap-2">
            Actions <Icon1 icon_name="menu" fill="white"></Icon1>
          </div>
        </PrimaryButton>
        {anchorEl && (
          <>
            {" "}
            <div
              onClick={handleClose}
              className="fixed top-0 left-0  h-screen w-screen z-40"
            ></div>
            <div
              id="basic-menu"
              className="absolute top-7 flex flex-col   left-0 z-50 w-c300 bg-white rounded-lg shadow-lg p-4"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <div
                className="flex flex-row cursor-pointer py-2 px-4 rounded-full hover:bg-neutral-100 gap-2"
                onClick={actionModify}
              >
                <div className="">
                  <Icon1 icon_name="modify"></Icon1>
                </div>
                <Space x={2} />
                <div className="flex flex-grow flex-row-reverse text-h2">
                  Modifier
                </div>
              </div>
              {userData.org_admin && (
                <div
                  className="flex flex-row cursor-pointer py-2 px-4 rounded-full hover:bg-neutral-100 gap-2"
                  onClick={() => {
                    setOpenDelete(true);
                    handleClose();
                  }}
                >
                  <div className="">
                    <Icon1 icon_name="delete"></Icon1>
                  </div>
                  <Space x={2} />
                  <div className="flex flex-grow flex-row-reverse text-h2">
                    Supprimer
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>{" "}
    </div>
  );
}
